import moment from 'moment-timezone';

export const isTimeBeforeTimeNow = (time: string) => {
	const timeNow = moment();
	return moment(time).isBefore(timeNow);
};

export const getFormattedTimeDifferenceComparedToTimeNow = (dateString: string) => {
	const momentTimeDifference = moment.duration(moment().diff(moment(dateString)));
	let timeDifferenceAsString;

	if (momentTimeDifference.asMinutes() < 60) {
		timeDifferenceAsString = momentTimeDifference.asMinutes().toFixed() + 'min';
	} else {
		timeDifferenceAsString = momentTimeDifference.asHours().toFixed() + 'hours';
	}
	return timeDifferenceAsString;
};
